import React from "react"
import ResourceSearchContainer from "../../containers/ResourceSearchContainer"

const ResourceSearchPage = () => {
  return <ResourceSearchContainer />
}

export default ResourceSearchPage
